import { render, staticRenderFns } from "./dateSearch.vue?vue&type=template&id=620868d9&scoped=true&"
import script from "./dateSearch.vue?vue&type=script&lang=js&"
export * from "./dateSearch.vue?vue&type=script&lang=js&"
import style0 from "./dateSearch.vue?vue&type=style&index=0&id=620868d9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620868d9",
  null
  
)

export default component.exports